<script lang="ts">
	import UnitManagement from 'src/components/Settings/HomeManagement/UnitManagement.svelte';
	import SharedHomesToMeList from 'src/components/Settings/HomeManagement/SharedHomesToMeList.svelte';
	import PendingHomesList from 'src/components/Settings/HomeManagement/PendingHomesList.svelte';
</script>

<UnitManagement />
<SharedHomesToMeList />
<PendingHomesList />
